/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { space } from '@airwallex/global';
import { Body, Headline } from '@airwallex/typography';

import Divider from '@/components/common/divider';
import { logoContainerBasicCss, logoImgBasicCss } from '../styles';

export interface DesktopOrderInfoProps {
  logoUrl?: string;
  merchant?: string;
  title?: string;
  description?: string;
}

const DesktopOrderInfo: FC<DesktopOrderInfoProps> = ({ logoUrl, merchant, title, description, children }) => {
  const { t } = useTranslation();

  return (
    <div>
      {logoUrl && (
        <div css={logoContainerBasicCss}>
          <img css={logoImgBasicCss} src={logoUrl} alt="merchant-logo" />
        </div>
      )}
      {merchant && (
        <Body
          variant="100.Bold"
          css={css`
            margin-top: ${space.xl};
            word-wrap: break-word;
          `}
        >
          {`${t('pay_by_link.merchant_from')} ${merchant}`}
        </Body>
      )}
      {title && (
        <Headline
          variant="200"
          css={css`
            margin-top: ${space.xl};
            word-wrap: break-word;
          `}
        >
          {title}
        </Headline>
      )}
      {description && (
        <Body
          variant="100.Subtle"
          css={css`
            margin-top: ${space.xs};
            word-wrap: break-word;
          `}
        >
          {description}
        </Body>
      )}
      <Divider
        css={css`
          margin-top: ${space.xl};
        `}
      />
      {children}
    </div>
  );
};

export default DesktopOrderInfo;
